import {
  EnvelopeIcon,
  PhoneIcon
} from "@heroicons/react/24/outline";
import React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary py-8">
      <div className=" container mx-auto px-4 md:px-8 lg:px-12">
        <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 ">
          {/* First Column */}
          <div className=" text-center md:text-left ">
            <img
              className="h-12 w-auto mb-4 mx-auto md:mx-0"
              src="./k-pack.webp"
              alt="k-pack logo"
            />
            <p className="text-secondary">
              K-Pack Pvt. Limited delivers premium packaging solutions,
              specializing in high-quality flexible materials, with a strong
              focus on customer satisfaction and innovation.
            </p>
          </div>

          {/* Second Column */}
          <div className="flex flex-col  items-center text-center md:text-left ">
            <h3 className="text-lg text-secondary font-bold mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2 justify-center items-center flex flex-col">
              <li>
                <HashLink
                  smooth
                  to="/#home"
                  className="text-secondary hover:text-text-primary"
                >
                  Home
                </HashLink>
              </li>
              <li>
                <HashLink
                  smooth
                  to="/#about"
                  className="text-secondary hover:text-text-primary"
                >
                  About Us
                </HashLink>
              </li>
              <li>
                <HashLink
                  smooth
                  to="/#solutions"
                  className="text-secondary hover:text-text-primary"
                >
                  Solutions
                </HashLink>
              </li>
              <li>
                <HashLink
                  smooth
                  to="/#certifications"
                  className="text-secondary hover:text-text-primary"
                >
                  Our Certifications
                </HashLink>
              </li>
              <li>
                <Link
                  to="/ims-policy"
                  className="text-secondary hover:text-text-primary"
                >
                  IMS Policy
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/careers"
                  className="text-secondary hover:text-text-primary"
                >
                  Careers
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Third Column */}
          <div className="text-center flex flex-col items-center  md:text-left ">
            <h3 className="text-lg text-secondary font-bold mb-4">
              Contact Info
            </h3>
            <ul className="space-y-2">
              <li className="flex justify-center md:justify-start items-center">
                <EnvelopeIcon className="h-5 w-5 text-text-primary mr-2" />
                <a
                  href="mailto:info@k-pack.pk"
                  className="text-secondary hover:text-text-primary"
                >
                  info@k-pack.pk
                </a>
              </li>
              <li className="flex justify-center md:justify-start items-center">
                <PhoneIcon className="h-5 w-5 text-text-primary mr-2" />
                <a
                  href="tel:+924235297277"
                  className="text-secondary hover:text-text-primary"
                >
                  +924235297277 <span className="ml-1 text-xs">(landline)</span>
                </a>
              </li>
              <li className="flex justify-center md:justify-start items-center">
                <PhoneIcon className="h-5 w-5 text-text-primary mr-2" />
                <a
                  href="https://wa.me/923219497991"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary hover:text-text-primary"
                >
                  +923219497991 <span className="ml-1 text-xs">(whatsapp)</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider and Copyright */}
        <div className="border-t border-text-secondary mt-8 pt-4 text-center">
          <p className="text-secondary">
            &copy; {new Date().getFullYear()} K-Pack. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
